module.exports = __webpack_public_path__ + "static/media/icon-hand@3x.da9c506e.png";